import formReducer, { formHelperMethodFactory } from 'reducers/FormReducer/FormReducer'
import {
  createFormField,
  withValidationFactory,
  type BaseValidationField,
  type FormReducerSingleTextField,
  type PickByType,
  type ValidationObject,
} from 'reducers/FormReducer/utils'
import type { ExtractElementType, ProductsDetailDataV5 } from 'utils/utils.d'

type variantDetailData = ExtractElementType<NonNullable<ProductsDetailDataV5['variants']>>

export interface EditVariantFormReducerState {
  reference_name: FormReducerSingleTextField
  variant_id: FormReducerSingleTextField
  reference_image_url: FormReducerSingleTextField

  //   share attributes
  quantity: FormReducerSingleTextField
  size: FormReducerSingleTextField
  colour: FormReducerSingleTextField
  flavour: FormReducerSingleTextField
  format: FormReducerSingleTextField
  formulation: FormReducerSingleTextField
  product_dimensions: FormReducerSingleTextField
  pack_count: FormReducerSingleTextField
  model_number: FormReducerSingleTextField
}

type PickEditVariantStateField<T> = PickByType<EditVariantFormReducerState, T>

// Define the keys of the fields that match the correct element types
export type EditVariantSingleTextField = PickEditVariantStateField<FormReducerSingleTextField>

// Get the keys of the fields that have a value and an error field
export type EditVariantValidationFields = BaseValidationField<EditVariantFormReducerState>

export const defaultEditVariantErrorObject: ValidationObject<'EditVariantFormReducerState'> = {}
const withValidation = withValidationFactory(defaultEditVariantErrorObject)

// Define the initial state of the form
export const initialEditVariantFormReducerState = (data: variantDetailData): EditVariantFormReducerState => ({
  reference_name: withValidation(
    createFormField('text', data.reference_name || ''),
    'reference_name',
    ['requiredField'],
    [],
  ),
  variant_id: withValidation(createFormField('text', data.variant_id || ''), 'variant_id', ['requiredField'], []),
  reference_image_url: withValidation(
    createFormField('text', data.reference_image_url || ''),
    'reference_image_url',
    [],
    [],
  ),

  //   share attributes
  quantity: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'quantity')?.value || ''),
    'quantity',
    [],
    [],
  ),
  size: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'size')?.value || ''),
    'size',
    [],
    [],
  ),
  colour: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'colour')?.value || ''),
    'colour',
    [],
    [],
  ),
  flavour: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'flavour')?.value || ''),
    'flavour',
    [],
    [],
  ),
  format: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'format')?.value || ''),
    'format',
    [],
    [],
  ),
  formulation: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'formulation')?.value || ''),
    'formulation',
    [],
    [],
  ),
  product_dimensions: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'product_dimensions')?.value || ''),
    'product_dimensions',
    [],
    [],
  ),
  pack_count: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'pack_count')?.value || ''),
    'pack_count',
    [],
    [],
  ),
  model_number: withValidation(
    createFormField('text', data.attributes?.find(({ name }) => name === 'model_number')?.value || ''),
    'model_number',
    [],
    [],
  ),
})

const editVariantFormReducer = formReducer<'EditVariantFormReducerState'>
export const editVariantFormHelperFunctions = formHelperMethodFactory<'EditVariantFormReducerState'>()
export default editVariantFormReducer
